import { Divider, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'
import { FormDataConsumer } from 'react-admin'

export const getResourceSingleLabel = (resourceConfig) =>
  resourceConfig?.options?.singleLabel ? resourceConfig.options.singleLabel : 'Resource'

export const getResourceSuccessMessage = (resource, context, type) => `resources.${resource}.${context}.${type}.success`

export const CardTitle = ({ text, size, sx = {}, args = {} }) => {
  const translate = useTranslate()
  return (
    <Typography variant="h6" sx={{ fontSize: size, fontWeight: 500, ...sx }}>
      {translate(text, args)}
    </Typography>
  )
}

export const FormDivider = ({ condition }) => (
  <FormDataConsumer>{({ formData }) => (!condition || condition(formData) ? <Divider /> : null)}</FormDataConsumer>
)
